import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { scheduleDowngradesApi } from "@/react/api/scheduleDowngradesApi";
import { useToast } from "@circle-react-uikit/ToastV2";
import { UPGRADE_PATHS } from "../components/shared/UpgradePlan/constants";

// Types for the API response
interface AccountSubscription {
  id: number;
}

interface ScheduleDowngradeSuccessResponse {
  data: AccountSubscription;
}

interface CancelDowngradeSuccessResponse {
  success: true;
}

interface ScheduleDowngradeErrorResponse {
  error_details?: unknown;
  message: string;
  success: false;
}

export const useScheduleDowngradesApi = () => {
  const { success, error } = useToast();
  const history = useHistory();
  const { mutate: scheduleDowngrade, isLoading: isSchedulingDowngrade } =
    useMutation<
      ScheduleDowngradeSuccessResponse,
      ScheduleDowngradeErrorResponse,
      string
    >((planId: string) => scheduleDowngradesApi.create(Number(planId)), {
      onSuccess: () => {
        history.push(UPGRADE_PATHS.SCHEDULED_DOWNGRADE_SUCCESS);
        success(t("pricing_plans.subscription_updated"));
      },
      onError: () => {
        error(t("pricing_plans.errors.schedule_downgrade_error"));
      },
    });

  const { mutate: cancelScheduledDowngrade, isLoading: isCancelingDowngrade } =
    useMutation<
      CancelDowngradeSuccessResponse,
      ScheduleDowngradeErrorResponse,
      void
    >(() => scheduleDowngradesApi.cancel(), {
      onSuccess: () => {
        success(t("pricing_plans.downgrade_schedule_cancelation.success"));
      },
      onError: () => {
        error(t("pricing_plans.downgrade_schedule_cancelation.error"));
      },
    });

  return {
    scheduleDowngrade,
    isSchedulingDowngrade,
    cancelScheduledDowngrade,
    isCancelingDowngrade,
  };
};
